module.exports = __webpack_public_path__ + "img/case-user-ava3.1d8c0de9.png";